import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { setBookingEnabled } from "../../../../CastingBotFirebase";

function ManageOverviewTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;
  const [bookingOpen, setBookingOpen] = useState(castingData.booking_enabled);

  const statusColour = bookingOpen? '#2ecc71' : '#e74c3c';

  return (
    <SubTabParent passData={props}>

      <SubTabSection title='Allow Booking' description='Toggle the button below to open / close audition booking'>
        <div className='sl-center sl-column'>
          <FontAwesomeIcon icon={faCircle} size='2x' style={{color: statusColour}} />
          <div className='sl-row'>
            Booking is 
            <div style={{color: statusColour}}>{bookingOpen? 'OPEN' : 'CLOSED'}</div>
          </div>
          <p>
            Visitors {bookingOpen? 'can' : 'cannot'} book an audition {bookingOpen? 'through your Booking Page' : 'until you enable booking'}
          </p>
          <button 
            style={{backgroundColor: props.accentColour}} 
            onClick={() => setBookingEnabled(!bookingOpen, setBookingOpen, userData.active_organisation_id, castingData.uid, castingData, setCastingData)}
          >
              {bookingOpen? 'Disable' : 'Enable'} Booking
          </button>
        </div>
      </SubTabSection>

    </SubTabParent>
  )

}

export default ManageOverviewTab;